import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React, { JSX } from "react";

import { Bold } from "../common/Bold";

export const TariffCodesIA = () => {
  return (
    <Column>
      <Typography>
        <StrictLocalMsg
          defaultMessage="Tariff codes, also known as Harmonized System (HS) codes, are a universally used classification system by international customs authorities. <BoldFormatting>Tariff codes are required on all cross-border commercial invoices</BoldFormatting>."
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Introduction to tariff codes",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Faire-generated commercial invoices support only 6-digit tariff codes. If your products require longer codes, such as 10-digit tariff codes, we recommend creating your own commercial invoices."
          description={{
            text: "Information about Faire's support for tariff codes",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="You may provide a 6-digit tariff code for each product under <BoldFormatting>Inventory Details</BoldFormatting> in the product editor."
          values={{
            BoldFormatting,
          }}
          description={{
            text: "Instructions for adding tariff codes",
          }}
        />
      </Typography>
      <Spacer height="1x" />
      <Typography>
        <StrictLocalMsg
          defaultMessage="Since tariff codes are universal, you can use any code finder to update your products. Choose the classification and sections that best suit your products. If you’re unsure which tariff code to use, we recommend contacting a customs broker."
          description={{
            text: "Advice on finding and using tariff codes",
          }}
        />
      </Typography>
    </Column>
  );
};

const BoldFormatting = (chunks: JSX.Element) => <Bold>{chunks}</Bold>;
